import { Select } from "../../Helper/RegistrationHelper";


export const initialValues = {
  user_id: '',
  venue_id: '',
  user_name: {
    value: '',
    error: '',
    required: true,
    // validate: 'text',
    minLength: 2,
    maxLength: 50,
    helperText: 'Custom error message'
  },
  country_code: {
    value: '',
    error: '',
    validate: 'select'
  },
  mobile_no: {
    value: '',
    error: '',
    validate: 'phone',
    required: true,
    maxLength: 15
  },
  email: {
    value: '',
    error: '',
    validate: 'email',
    required: true,
  },
  password: {
    value: '',
    error: '',
    validate: 'password',
    required: true,
  },
  confirmpassword: {
    value: '',
    error: '',
    validate: 'confirmpassword',
    required: true,
  },
  //--------------Venue Registration -------------
  venuename: {
    value: '',
    error: '',
    required: true,
    // validate: 'text',
    minLength: 2,
    maxLength: 50,
    helperText: 'Custom error message'
  },
  venuetype: {
    value: '',
    error: '',
    validate: {Select}
  },
  venuecountry: {
    value: '',
    error: '',
    validate: 'select'
  },
  venuemobileno: {
    value: '',
    error: '',
    validate: 'phone',
    required: true,
    maxLength: 15
  },
  venueemail: {
    value: '',
    error: '',
    required: true,
    validate: 'email'
  },
  venueCurrency: {
    value: '',
    error: '',
    validate: 'text',
    minLength: 2,
    maxLength: 10,
    helperText: 'Custom error message'
  },  
 
  venuestate: {
    value: '',
    error: '',
    validate: 'select'
  },
venuecity: {
      value: '',
      error: '',
      validate: 'text',
      minLength: 3,
      maxLength: 50,
    },
venueaddress: {
      value: '',
      error: '',
      // validate: 'text',
      minLength: 3,
      maxLength: 70,
      required: true,
    },
venuepincode:  {
    value: '',
    error: '',
    validate: 'number',
    maxLength: 6,
    required: true,
} ,
businesslabel:{
  value: '',
  error: '',
  // validate: 'text',
  required: false,
},
businessnumber:{
  value: '',
  error: '',
  validate: 'number',
  required: false,
},
venuewebsiteurl: {
    value: '',
    error: '',
    // validate: 'text|number',
    minLength: 0,
    maxLength: 50,
    required: false,
  },   
//   date: {
//     value: '',
//     error: ''
//   },
//   agreenemt: {
//     value: false,
//     error: '',
//     required: true,
//     validate: 'checkbox',
//     helperText: 'Please accept our terms and conditions'
//   },
  
}
